module.exports = __webpack_public_path__ + "assets/img/star-5.7ce5c84b.svg";